export class OrganizationModel {
    organizationId: string;
    organizationName: string;
}
export class CustomerAndOrganizations {
    customerId: string;
    customerName: string;
    organizations: OrganizationModel[] = [];
}